module.exports = __webpack_public_path__ + "img/destination_dubai.6e55caa2.webp";